import { NoData } from "app/pages/industry-analysis/frame/NoData";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";

import { usePrimaryCategoryObject } from "../common/hooks/usePrimaryCategoryObject";

export const WithIsEmptyIndustry = (Component) => {
    return function WrappedComponent(props) {
        const categoryObject = usePrimaryCategoryObject();

        if (!categoryObject) {
            return (
                <NoData
                    noDataTitleKey={"global.nodata.notavilable"}
                    noDataSubTitleKey={"workspaces.marketing.nodata.subtitle"}
                />
            );
        }

        const isEmptyIndustry = CategoryServiceUtils.isEmptyIndustry(categoryObject);

        if (isEmptyIndustry) {
            return (
                <NoData
                    noDataTitleKey={"industry.research.empty.industry.title"}
                    noDataSubTitleKey={"industry.research.empty.industry.subtitle"}
                />
            );
        }
        return <Component {...props} />;
    };
};
